export const frLocale = {
	months: [
		"Janvier",
		"Février",
		"Mars",
		"Avril",
		"Mai",
		"Juin",
		"Juillet",
		"Août",
		"Septembre",
		"Octobre",
		"Novembre",
		"Décembre",
	],
	monthsShort: [
		"Jan",
		"Fév",
		"Mar",
		"Avr",
		"Mai",
		"Juin",
		"Juil",
		"Aoû",
		"Sep",
		"Oct",
		"Nov",
		"Déc",
	],
	weekdays: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
	weekdaysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
	weekdaysMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
	longDateFormat: {
		LT: "HH:mm",
		LTS: "HH:mm:ss",
		L: "DD/MM/YYYY",
		LL: "D MMMM YYYY",
		LLL: "D MMMM YYYY HH:mm",
		LLLL: "dddd D MMMM YYYY HH:mm",
	},
	calendar: {
		sameDay: "[Aujourd’hui à] LT",
		nextDay: "[Demain à] LT",
		nextWeek: "dddd [à] LT",
		lastDay: "[Hier à] LT",
		lastWeek: "[Dernier] dddd [à] LT",
		sameElse: "L",
	},
	relativeTime: {
		future: "dans %s",
		past: "il y a %s",
		s: "quelques secondes",
		ss: "%d secondes",
		m: "une minute",
		mm: "%d minutes",
		h: "une heure",
		hh: "%d heures",
		d: "un jour",
		dd: "%d jours",
		M: "un mois",
		MM: "%d mois",
		y: "un an",
		yy: "%d ans",
	},
	dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	ordinal: (n: number) => (n === 1 ? `${n}er` : `${n}e`),
	week: {
		dow: 1, // Lundi est le premier jour de la semaine.
		doy: 4, // La semaine contenant le 4 janvier est la première semaine de l'année.
	},
};
